export function tabs() {
    let tabNav = $(".tab-nav li");
    tabNav.on("click", "a", function (e) {
        e.preventDefault();
        let $this = $(this);
        if (!$this.hasClass("active")) {
            tabNav.removeClass("active");
            $this.parent().addClass("active");
            let target = $this.attr("href");
            let parent = $(target).parent(".tab-info-holder");
            parent.find('.tab-info').removeClass("active");
            $(target).addClass("active");
        }
        checkActive();
    })
    let $arrowleft = $(".tab-info-holder .arrow-left"), $arrowRight = $(".tab-info-holder .arrow-right");

    function checkActive() {
        if (tabNav.first().hasClass('active')) {
            $arrowleft.prop("disabled", true);
        } else {
            $arrowleft.prop("disabled", false);
        }
        if (tabNav.last().hasClass('active')) {
            $arrowRight.prop("disabled", true);
        } else {
            $arrowRight.prop("disabled", false);
        }
    }

    $arrowleft.click(function () {
        if ($(".tab-nav li.active").prev('li').length > 0) {
            $(".tab-nav li.active").prev('li').find('a').click()
        }
    })
    $arrowRight.click(function () {
        if ($(".tab-nav li.active").next('li').length > 0) {
            $(".tab-nav li.active").next('li').find('a').click()
        }

    })

    var timer = null;

    function startSetInterval() {
        timer = setInterval(function () {
            if ($(".tab-nav li.active").next('li').length > 0) {
                $(".tab-nav li.active").next('li').find('a').click()
            } else {
                tabNav.first().find('a').click()
            }
        }, 3000);
    }

    // start function on page load
    startSetInterval();

    $('.tab-holder').hover(function () {
        clearInterval(timer);

    }, function () {

        startSetInterval();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js